<template>
    <div class="input-group">
        <span
            class="input-group-text"
            @click.prevent="$refs.datepicker.focus()"
        >
            <i class="fa fa-calendar" style="font-size: 16px"></i
        ></span>
        <input
            :id="'datepicker' + reference"
            ref="datepicker"
            :class="classes"
            :name="name"
            :placeholder="placeholder"
        />
        <span
            v-if="modelValue != null"
            class="input-group-text"
            @click.prevent="reset()"
        >
            <i class="fa fa-times"></i>
        </span>
    </div>
</template>

<script>
export default {
    props: {
        modelValue: null,
        classes: {
            type: String,
            default: "",
        },
        name: {
            type: String,
            default: "",
        },
        minYear: {
            type: Number,
            default: null,
        },
        maxYear: {
            type: Number,
            default: null,
        },
        format: {
            type: String,
            default: "DD/MM/YYYY",
        },
        applyLabel: {
            type: String,
            default: "Aplicar",
        },
        cancelLabel: {
            type: String,
            default: "Cancelar",
        },
        fromLabel: {
            type: String,
            default: "De",
        },
        toLabel: {
            type: String,
            default: "Hasta",
        },
        singleDatePicker: {
            type: Boolean,
            default: true,
        },
        timePicker: {
            type: Boolean,
            default: false,
        },
        daysOfWeek: {
            type: Array,
            default: () => ["Dom", "Lun", "Mar", "Mie", "Jue", "Vie", "Sáb"],
        },
        monthNames: {
            type: Array,
            default: () => [
                "Enero",
                "Febrero",
                "Marzo",
                "Abril",
                "Mayo",
                "Junio",
                "Julio",
                "Agosto",
                "Septiembre",
                "Octubre",
                "Noviembre",
                "Diciembre",
            ],
        },
        placeholder: {
            type: String,
            default: "",
        },
    },
    created() {
        this.reference = Math.random().toString(36).slice(2);
        if (global.datepicker == undefined) {
            global.datepicker = [];
        }
        datepicker.push({
            ref: "datepicker" + this.reference,
            instance: this,
        });
    },
    watch: {
        modelValue: function (val, old) {
            if (val) {
                this.$refs.datepicker.value = val;
                $("#datepicker" + this.reference)
                    .data("daterangepicker")
                    .setStartDate(val);
            }
        },
    },
    mounted() {
        this.init();
        if (this.modelValue != null) {
            this.$refs.datepicker.value = this.modelValue;
        }
    },
    methods: {
        init() {
            $("#datepicker" + this.reference)
                .daterangepicker({
                    locale: {
                        format: this.format,
                        applyLabel: this.applyLabel,
                        cancelLabel: this.cancelLabel,
                        fromLabel: this.fromLabel,
                        toLabel: this.toLabel,
                        customRangeLabel: "Custom",
                        daysOfWeek: this.daysOfWeek,
                        monthNames: this.monthNames,
                    },
                    timePicker: this.timePicker,
                    singleDatePicker: this.singleDatePicker,
                    showDropdowns: true,
                    minYear: this.minYear,
                    maxYear: this.maxYear,
                })
                .on("cancel.daterangepicker", function (ev, Picker) {
                    datepicker.forEach((element) => {
                        if (element.ref == ev.target.id) {
                            element.instance.cancel();
                        }
                    });
                })
                .on("apply.daterangepicker", function (ev, Picker) {
                    datepicker.forEach((element) => {
                        if (element.ref == ev.target.id) {
                            element.instance.set(
                                Picker.startDate.format(
                                    element.instance.format
                                ),
                                Picker.endDate.format(element.instance.format)
                            );
                        }
                    });
                });

            // this.$emit("update:modelValue", moment().format(this.format));
            $("#datepicker" + this.reference).val("");
        },
        set(start, end) {
            if (start != null && end != null) {
                if (this.singleDatePicker) {
                    this.$emit("update:modelValue", start);
                } else {
                    this.$emit("update:modelValue", start + " - " + end);
                }
            }
        },
        reset() {
            $("#datepicker" + this.reference).val("");
            this.$emit("update:modelValue", null);
        },
        cancel() {
            if (this.modelValue == null) {
                $("#datepicker" + this.reference).val("");
            } else {
                $("#datepicker" + this.reference)
                    .data("daterangepicker")
                    .setStartDate(this.modelValue);
            }
        },
    },
};
</script>
